// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyCardFinderRequest {
    static getAttributeTypeMap() {
        return PharmacyCardFinderRequest.attributeTypeMap;
    }
}
PharmacyCardFinderRequest.discriminator = undefined;
PharmacyCardFinderRequest.additionalProperties = false;
PharmacyCardFinderRequest.attributeTypeMap = [
    {
        "name": "mock",
        "baseName": "mock",
        "type": "boolean"
    },
    {
        "name": "daysSupply",
        "baseName": "daysSupply",
        "type": "string"
    },
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "PharmacyCardFinderPatientRequest"
    },
    {
        "name": "pharmacyNcpDpId",
        "baseName": "pharmacyNcpDpId",
        "type": "string"
    },
    {
        "name": "pharmacyNpi",
        "baseName": "pharmacyNpi",
        "type": "string"
    },
    {
        "name": "prescriber",
        "baseName": "prescriber",
        "type": "PharmacyCardFinderPrescriber"
    },
    {
        "name": "quantity",
        "baseName": "quantity",
        "type": "string"
    },
    {
        "name": "clientId1",
        "baseName": "clientId1",
        "type": "string"
    },
    {
        "name": "clientId2",
        "baseName": "clientId2",
        "type": "string"
    },
    {
        "name": "clientId3",
        "baseName": "clientId3",
        "type": "string"
    },
    {
        "name": "clientId4",
        "baseName": "clientId4",
        "type": "string"
    },
    {
        "name": "clientId5",
        "baseName": "clientId5",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyCardFinderRequest.js.map